/* storybook-check-ignore */
import { Box } from '@opendoor/bricks-next';

import { is3PExclusive } from 'components/marketplace/helpers';
import { FooterCta, PropertyDetailsType, SimilarListings } from 'components/marketplace/property';

import { useCustomerToursContext } from '../context/customerToursContext';
import { PropertyCTAs } from './PropertyCTAs';
import { PropertyDetails } from './PropertyDetails';
import { PropertyStatus } from './PropertyStatus';
import { PropertySummary } from './PropertySummary';

type PropertySectionProps = {
  property: PropertyDetailsType;
};

export const PropertySection = ({ property }: PropertySectionProps) => {
  const { tours, loading } = useCustomerToursContext();

  const scheduledTour = !!tours.find(
    (tour) =>
      tour.state === 'PENDING' ||
      tour.state === 'PENDING_VERIFICATION' ||
      tour.state === 'SCHEDULED',
  );

  const is3PE = is3PExclusive(property);

  return (
    <Box
      flexDirection="column"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $largerThanSM={{ flexBasis: '50%', mt: 55, overflowY: 'scroll' }}
      $largerThanLG={{ maxWidth: '$736x' }}
    >
      <Box $largerThanSM={{ px: 48 }} $smallerThanMD={{ px: 24 }} pt={24}>
        <PropertyStatus property={property} />
        <PropertySummary property={property} />
        <PropertyCTAs property={property} />
        <PropertyDetails property={property} />
        <Box tag="section">
          <SimilarListings listings={property?.similarProperties?.results || []} />
        </Box>
      </Box>
      {/** Enable the "Self-tour now" CTA for homes that are self-tourable in non-Buy Direct markets (SFO, NYC, DC) */}
      {((!is3PE && property.displayBadge === 'ON_THE_MARKET') || property?.canSelfTour) && (
        <FooterCta kind="selfTour" property={property} />
      )}
      {is3PE &&
        !loading &&
        property.listingState === 'ON_THE_MARKET' &&
        (scheduledTour ? (
          <FooterCta kind="cancelTour" property={property} isExclusive />
        ) : (
          <FooterCta kind="scheduleTour" property={property} isExclusive />
        ))}
    </Box>
  );
};
